import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export class LaboratoryRefreshInfoCommand extends Command<null, boolean> {}

export class LaboratoryRefreshInfoCommandBase implements CommandHandler<LaboratoryRefreshInfoCommand, null, boolean> {
    private static Url = TaggedUrl.join('myCompany/laboratory/refresh', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) { }

    public async handleAsync(_: LaboratoryRefreshInfoCommand): Promise<boolean> {
        return await this.http.post(LaboratoryRefreshInfoCommandBase.Url).then(() => true, () => false);
    }
}
